import { FC, ReactNode } from "react";

type PageHeroProps = {
  eyebrow: string;
  title: string;
  description?: ReactNode;
};

// Top band for inner public pages, matching the landing page hero
export const PageHero: FC<PageHeroProps> = ({ eyebrow, title, description }) => (
  <section className="relative w-full overflow-hidden bg-gradient-to-b from-surface via-surface to-surface-container-low/60 pt-28 pb-12 sm:pt-36 sm:pb-16">
    <div className="absolute -top-32 -left-20 w-96 h-96 rounded-full bg-primary/10 blur-3xl pointer-events-none" />
    <div className="absolute -top-16 -right-24 w-96 h-96 rounded-full bg-secondary-container/10 blur-3xl pointer-events-none" />
    <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 flex flex-col items-center text-center gap-4">
      <span className="inline-flex items-center gap-2.5 px-4 py-1.5 rounded-full bg-surface-container-highest/80 shadow-sm">
        <span className="w-2 h-2 rounded-full bg-tertiary" />
        <span className="font-label-sm text-label-sm uppercase tracking-wider text-primary">
          {eyebrow}
        </span>
      </span>
      <h1 className="font-display-mobile text-display-mobile md:font-display md:text-display text-on-surface">
        {title}
      </h1>
      {description && (
        <p className="font-body-lg text-body-lg text-on-surface-variant max-w-2xl">
          {description}
        </p>
      )}
    </div>
  </section>
);
